import React from 'react';
import { Row, Col, Button } from 'react-bootstrap';
import { formatMoney } from '../../utils/formatMoney';
import { apiUrl, businessName } from '../../utils/consts';
import { connect } from 'react-redux';
import moment from 'moment';

const select = state => {
  return {
    userId: state.auth.userId,
    token: state.auth.token
  };
};

function ConnectedShoppingCartItem(props) {

  const { item, userId, token } = props;

  const handleDeleteItem = async id => {
    const prom = await fetch(`${apiUrl}/shoppingCart/delete`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        userId,
        businessName,
        token,
        id
      })
    });

    const json = await prom.json();

    if (json.success) props.refresh();
  };

  return (
    <Row>
      <Col md={2}>
        <div className="itemImgContainer">
          <img src={item.product.thumbnail} className="itemImg" alt="Imagen del producto" />
        </div>
      </Col>
      <Col md={6}>
        <div className="itemName">
          {item.product.name}
        </div>
        <div className="dateAdded">
          Agregado el {moment(item.dateCreated).format('YYYY-MM-DD')}
        </div>
        {
          item.variant &&
          <div className="dateAdded">
            Opción: {item.variant.name}
          </div>
        }
        <div className="actionBar"></div>
      </Col>
      <Col md={4}>
        <div className="itemPrice">
          <div style={{ marginBottom: '10px' }}>
            COP {formatMoney(item.amount)}
          </div>
          <Button variant="outline-danger" onClick={() => handleDeleteItem(item._id)}>
            <i
              className="fa fa-trash"
              style={{ color: 'firebrick', cursor: 'pointer' }}
            />
          </Button>
        </div>
      </Col>
    </Row>
  );
}

const ShoppingCartItem = connect(select)(ConnectedShoppingCartItem);

export default ShoppingCartItem;
